import { makeStyles } from "tss-react/mui";
import { getContrastColor } from "@miplatform/utils";
import { Box, Typography } from "@mui/material";

export const MiAbbreviationBadge = ({
  abbreviation,
  backgroundColor,
  disabled,
  styles,
}: MiAbbreviationBadgeProps) => {
  const { classes, theme } = useStyles();
  return (
    <Box
      className={classes.miAbbreviationBadgeContainer}
      style={styles}
      sx={{ backgroundColor, opacity: disabled ? 0.5 : 1 }}
    >
      <Typography
        fontSize={theme.fontSize.xsmall}
        color={getContrastColor(backgroundColor)}
      >
        {abbreviation}
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  miAbbreviationBadgeContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minWidth: 30,
    height: 20,
    borderRadius: 2,
  },
}));

interface MiAbbreviationBadgeProps {
  abbreviation: string;
  backgroundColor?: string;
  disabled?: boolean;
  styles?: React.CSSProperties;
}
